/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Vision UI Dashboard React components
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      component="footer"
      py={2}
      pb={0}
    >
      <VuiBox mb={1}>
        <VuiTypography
          variant="button"
          sx={{ textAlign: "center", fontWeight: "400 !important" }}
          color="white"
        >
          © 2025 Mytherra Blockchain. All rights reserved.
        </VuiTypography>
      </VuiBox>
      <VuiBox>
        <VuiTypography
          variant="button"
          sx={{ textAlign: "center", fontWeight: "400 !important" }}
          color="text"
        >
          Built with ❤️ for the decentralized future
        </VuiTypography>
      </VuiBox>
    </VuiBox>
  );
}

export default Footer;
